import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Wrapper,
  Title,
  Copy,
  Row,
  ProgressBar
} from "app/NativeComponents/common";

import {
  appRedirect,
  setBillingDetails,
  setFeatureModal,
  setPricingPage,
  togglePricingPage,
  openUrl
} from "app/NativeActions";

import { PillButton } from "app/NativeComponents/snippets";

import {
  renderPrice,
  numberWithCommas,
  checkIfUserHasModule
} from "app/NativeActions";

class PlanModule extends Component {
  constructor(props) {
    super(props);
    const plan_module_info = checkIfUserHasModule({
      plan_modules: props.plan_modules,
      user: props.user,
      slug: props.slug
    });
    this.state = {
      plan_module_info: plan_module_info
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.user && prevProps.plan_modules) {
      if (
        this.props.plan_modules !== prevProps.plan_modules ||
        this.props.user.plan_modules !== prevProps.user.plan_modules
      ) {
        const plan_module_info = checkIfUserHasModule({
          plan_modules: this.props.plan_modules,
          user: this.props.user,
          slug: this.props.slug
        });
        this.setState({ plan_module_info: plan_module_info });
      }
    }
  }

  renderCopy() {
    if (this.props.slug !== "crm") {
      if (
        (this.state.plan_module_info.team_has_module ||
          this.state.plan_module_info.approved_to_charge == 0) &&
        this.state.plan_module_info.canceled != 1 &&
        this.state.plan_module_info.paused != 1
      ) {
        if (
          this.state.plan_module_info.selected_plan == true &&
          this.state.plan_module_info.approved_to_charge == 0
        ) {
          return <Copy>Talk to sales to unlock your account.</Copy>;
        }

        switch (parseInt(this.state.plan_module_info.current_tier)) {
          default:
            return null;
          case -1:
            return <Copy>Paused Plan</Copy>;

          case 1:
            return <Copy>Basic Plan</Copy>;

          case 2:
            return <Copy>Professional Plan</Copy>;

          case 3:
            return <Copy>Enterprise Plan</Copy>;
        }
      } else if (this.state.plan_module_info.canceled == 1) {
        return <Copy>Canceled Plan</Copy>;
      } else if (this.state.plan_module_info.paused == 1) {
        return <Copy>Paused Plan</Copy>;
      }
    } else {
      if (this.props.loading) {
        return <Wrapper />;
      }

      if (this.props.additional_limit_price > 0) {
        return (
          <Copy>
            {renderPrice(this.props.additional_limit_price)} per month
          </Copy>
        );
      }

      //return <Copy>Free</Copy>;
    }
  }

  renderFreeTrialCopy() {}

  redirect() {}

  renderIOSDisclaimer() {
    if (this.props.slug === "crm") return;

    if (
      (this.state.plan_module_info.team_has_module ||
        this.state.plan_module_info.approved_to_charge == 0) &&
      this.state.plan_module_info.canceled != 1 &&
      this.state.plan_module_info.paused != 1
    ) {
      if (this.state.plan_module_info.current_tier == 1) {
        return (
          <Copy>
            Check out DealMachine on the web to upgrade To upgrade To
            Professional
          </Copy>
        );
      } else if (this.state.plan_module_info.current_tier == 2) {
        return (
          <Copy>Check out DealMachine on the web to upgrade To Enterprise</Copy>
        );
      }
    } else if (this.state.plan_module_info.canceled == 1) {
      if (this.state.plan_module_info.canceled_access) {
        return <Copy>Visit DealMachine on the web to reactivate</Copy>;
      }
      return (
        <Copy>Check out DealMachine on the web to enable this feature</Copy>
      );
    } else if (this.state.plan_module_info.paused == 1) {
      return <Copy>Visit DealMachine on the web to reactivate</Copy>;
    } else {
      return (
        <Copy>Check out DealMachine on the web to enable this feature</Copy>
      );
    }
  }

  renderBuyButton() {
    if (this.props.slug !== "crm") {
      if (
        this.state.plan_module_info.team_has_module &&
        this.state.plan_module_info.canceled != 1 &&
        this.state.plan_module_info.paused != 1
      ) {
        if (this.state.plan_module_info.current_tier == 1) {
          return (
            <PillButton
              onPress={() => {
                this.props.setPricingPage({
                  title: "Upgrade Engine",
                  engine_slug: this.props.slug,
                  tier: 2,
                  frequency: this.state.plan_module_info.plan_frequency
                });
                this.props.togglePricingPage(true);
              }}
              primary={true}
              innerStyle={{ padding: 5, paddingRight: 15, paddingLeft: 15 }}
              style={{ margin: 0, marginRight: 5 }}
            >
              Upgrade To Professional
            </PillButton>
          );
        } else if (this.state.plan_module_info.current_tier == 2) {
          return (
            <PillButton
              onPress={() => {
                this.props.setPricingPage({
                  title: "Upgrade Engine",
                  engine_slug: this.props.slug,
                  tier: 3,
                  frequency: this.state.plan_module_info.plan_frequency
                });
                this.props.togglePricingPage(true);
              }}
              primary={true}
              innerStyle={{ padding: 5, paddingRight: 15, paddingLeft: 15 }}
              style={{ margin: 0, marginRight: 5 }}
            >
              Upgrade To Enterprise
            </PillButton>
          );
        }
      } else if (this.state.plan_module_info.canceled == 1) {
        if (this.state.plan_module_info.canceled_access) {
          return (
            <PillButton
              onPress={() => {
                this.props.setPricingPage({
                  title: "Reactivate Engine",
                  engine_slug: this.props.slug,
                  tier: this.state.plan_module_info.current_tier,
                  frequency: this.state.plan_module_info.plan_frequency
                });
                this.props.togglePricingPage(true);
              }}
              primary={true}
              innerStyle={{ padding: 5, paddingRight: 15, paddingLeft: 15 }}
              style={{ margin: 0, marginRight: 5 }}
            >
              Reactivate
            </PillButton>
          );
        }
        return (
          <PillButton
            onPress={() => {
              this.props.setPricingPage({
                title: "Purchase Engine",
                engine_slug: this.props.slug,
                tier: 1,
                frequency: "annually"
              });
              this.props.togglePricingPage(true);
            }}
            primary={true}
            innerStyle={{ padding: 5, paddingRight: 15, paddingLeft: 15 }}
            style={{ margin: 0, marginRight: 5 }}
          >
            Get Feature
          </PillButton>
        );
      } else if (this.state.plan_module_info.paused == 1) {
        return (
          <PillButton
            onPress={() => {
              this.props.setPricingPage({
                title: "Reactivate Engine",
                engine_slug: this.props.slug,
                tier: this.state.plan_module_info.current_tier,
                frequency: this.state.plan_module_info.plan_frequency
              });
              this.props.togglePricingPage(true);
            }}
            primary={true}
            innerStyle={{ padding: 5, paddingRight: 15, paddingLeft: 15 }}
            style={{ margin: 0, marginRight: 5 }}
          >
            Reactivate
          </PillButton>
        );
      } else if (
        this.state.plan_module_info.selected_plan == true &&
        this.state.plan_module_info.approved_to_charge == 0
      ) {
        return (
          <PillButton
            onPress={() => {
              openUrl("https://dealmachine.com/talk-to-sales");
            }}
            primary={true}
            innerStyle={{ padding: 5, paddingRight: 15, paddingLeft: 15 }}
            style={{ margin: 0, marginRight: 5 }}
          >
            Talk To Sales
          </PillButton>
        );
      } else {
        return (
          <PillButton
            onPress={() => {
              this.props.setPricingPage({
                title: "Purchase Engine",
                engine_slug: this.props.slug,
                tier: 1,
                frequency: "annually"
              });
              this.props.togglePricingPage(true);
            }}
            primary={true}
            innerStyle={{ padding: 5, paddingRight: 15, paddingLeft: 15 }}
            style={{ margin: 0, marginRight: 5 }}
          >
            Get Feature
          </PillButton>
        );
      }
    }
  }

  renderDetailsButton() {
    if (this.props.slug !== "crm") {
      if (
        (this.state.plan_module_info.team_has_module &&
          this.state.plan_module_info.canceled_access) ||
        (this.state.plan_module_info.paused == 1 &&
          this.state.plan_module_info.canceled != 1)
      ) {
        return (
          this.props.platform !== "ios" && (
            <PillButton
              onPress={() => {
                this.props.setBillingDetails({
                  title: this.props.title + " Billing Details",
                  plan_module_title: this.props.title,
                  slug: this.props.slug,
                  show_limits: this.props.show_limits,
                  plan_module_info: this.state.plan_module_info,
                  current_count: this.props.current_count,
                  current_limit: this.props.current_limit,
                  limit_title: this.props.limit_title
                });

                this.props.appRedirect({
                  redirect: "goForward",
                  payload: { add: "billing-details" }
                });
              }}
              innerStyle={{ padding: 5, paddingRight: 15, paddingLeft: 15 }}
              style={{ margin: 0, marginRight: 0 }}
            >
              Billing Details
            </PillButton>
          )
        );
      }
    }
  }

  renderLimits() {
    if (this.props.current_limit == -1) {
      return <Copy>Unlimited {this.props.limit_title}</Copy>;
    } else if (
      this.props.show_limits &&
      !this.props.loading &&
      this.props.current_limit > 0 &&
      this.props.current_limit
    ) {
      let count = this.props.current_count;
      if (count > this.props.current_limit) {
        count = this.props.current_limit;
      }

      return (
        <Wrapper>
          <ProgressBar
            color={this.props.colors.success_color}
            width={200}
            progress={parseInt(count) / parseInt(this.props.current_limit)}
          />
          <Copy>
            {numberWithCommas(this.props.current_count)} /{" "}
            {numberWithCommas(this.props.current_limit)}{" "}
            {this.props.limit_title}
          </Copy>
        </Wrapper>
      );
    }
  }

  render() {
    return (
      <Wrapper
        style={{
          padding: 20,
          borderBottomStyle: "solid",
          borderBottomWidth: 1,
          borderBottomColor: this.props.colors.border_color
        }}
      >
        <Wrapper style={{ paddingBottom: this.props.slug == "crm" ? 0 : 20 }}>
          <Title>{this.props.title}</Title>
          {this.renderCopy()}
          {this.renderLimits()}
        </Wrapper>
        <Wrapper>
          <Row>
            {this.props.platform !== "ios" && this.renderBuyButton()}
            {this.props.platform === "ios" && this.renderIOSDisclaimer()}
            {this.renderDetailsButton()}
          </Row>
        </Wrapper>
      </Wrapper>
    );
  }
}
const mapStateToProps = ({ auth, native, list }) => {
  const { token, user } = auth;
  const { actionSheet, device } = native;

  return {
    token,
    user,
    actionSheet,
    device
  };
};

export default connect(mapStateToProps, {
  appRedirect,
  setBillingDetails,
  setFeatureModal,
  setPricingPage,
  togglePricingPage,
  renderPrice,
  numberWithCommas,
  checkIfUserHasModule
})(PlanModule);
